import moment from "moment"
import { xlCol, xlColq } from "../../../common/constants"

export const selectOptions = [
    { name: "Citywise Branchwise", id: 0 },
    { name: "Citywise", id: 1 },
]
export const pdffilterHeader = [
    { headerName: 'Transaction From Date', exportHead: 'Transaction From Date', field: 'fromDate', xlCol: { dataType: 'string', dataFormatter: null }, colSpan: 9, align: "right" },
    { headerName: 'Transaction To Date', exportHead: 'Transaction To Date', field: 'toDate', xlCol: { dataType: 'number', dataFormatter: null }, colSpan: 9, align: "left" },
    { headerName: 'Selected Options', exportHead: 'Selected Options', field: 'selectedOption', xlCol: { dataType: 'string', dataFormatter: null }, colSpan: 9, align: "left" },
]
export const filterHeaderForExcel = [
    { headerName: 'Transaction From Date', exportHead: 'Transaction From Date', field: 'fromDate', xlCol: { dataType: 'string', dataFormatter: null }, colSpan: 8, align: "right" },
    { headerName: 'Transaction To Date', exportHead: 'Transaction To Date', field: 'toDate', xlCol: { dataType: 'number', dataFormatter: null }, colSpan: 9, align: "left" },
    { headerName: 'Selected Options', exportHead: 'Selected Options', field: 'selectedOption', xlCol: { dataType: 'string', dataFormatter: null }, colSpan: 9, align: "left" },
]
export const pdfheader = [
    { content: "Booked", colSpan: 15, styles: { halign: "center" } },
    { content: "Delivery", colSpan: 12, styles: { halign: "center" } }]

export const pdfSubHeader = [
    { content: "City\nName", field: 'CityName', styles: { halign: "left" } },
    { content: "Branch\nName", field: 'BranchName', styles: { halign: "left" } },
    { content: "Paid\nAmt.", field: 'BookedPaid', styles: { halign: "right" } },
    { content: "ToPay\nAmt.", field: 'BookedToPay', styles: { halign: "right" } },
    { content: "FOC\nAmt.", field: 'BookedFOC', styles: { halign: "right" } },
    { content: "COD\nAmt.", field: 'BookedCOD', styles: { halign: "right" } },
    { content: "On\nAccount", field: 'BookedOnAccount', styles: { halign: "right" } },
    { content: "ToPay\nDDDV", field: 'BookedToPayDDDV', styles: { halign: "right" } },
    { content: "Frght\nChrg.", field: 'BookedFreight', styles: { halign: "right" } },
    { content: "Doc.\nChrg.", field: 'BookedDocumentCharges', styles: { halign: "right" } },
    { content: "Ham.\nChrg.", field: 'BookedHamaliCharges', styles: { halign: "right" } },
    { content: "Op.\nHam.", field: 'BookedOperatorHamaliChg', styles: { halign: "right" } },
    { content: "Oth.\nChrg", field: 'BookedOtherCharges', styles: { halign: "right" } },
    { content: "BkgGST\nChrg.", field: 'BookedGST', styles: { halign: "right" } },
    { content: "Booked\nTotal", field: 'TotalBoookedPayment', styles: { halign: "right" } },
    { content: "Paid\nAmt.", field: 'DeliveredPaid', styles: { halign: "right" } },
    { content: "ToPay\nAmt.", field: 'DeliveredToPay', styles: { halign: "right" } },
    { content: "FOC\nAmt.", field: 'DeliveredFOC', styles: { halign: "right" } },
    { content: "COD\nAmt.", field: 'DeliveredCOD', styles: { halign: "right" } },
    { content: "On\nAccount", field: 'DeliveredOnAccount', styles: { halign: "right" } },
    { content: "ToPay\nDDDV", field: 'DeliveredToPayDDDV', styles: { halign: "right" } },
    { content: "Del.Ham\nChrg.", field: 'DeliveredHamali', styles: { halign: "right" } },
    { content: "Del.Op.Ham\nChrg.", field: 'DeliveryOtherHamali', styles: { halign: "right" } },
    { content: "Demm.\nChrg.", field: 'DeliveredInsurance', styles: { halign: "right" } },
    { content: "Other\nChrg.", field: 'DeliveredOtherCharges', styles: { halign: "right" } },
    { content: "Delivery\nGST", field: 'DeliveredGST', styles: { halign: "right" } },
    { content: "Delivery\nTotal", field: 'TotalDeliveredPayment', styles: { halign: "right" } }
]
export const pdfSubHeaderForBranch = [
    { content: "City\nName", field: "CityName", styles: { halign: "left" } },
    { content: "Paid\nAmt.", field: "BookedPaid", styles: { halign: "right" } },
    { content: "ToPay\nAmt.", field: "BookedToPay", styles: { halign: "right" } },
    { content: "FOC\nAmt.", field: "BookedFOC", styles: { halign: "right" } },
    { content: "COD\nAmt.", field: "BookedCOD", styles: { halign: "right" } },
    { content: "On\nAccount", field: "BookedOnAccount", styles: { halign: "right" } },
    { content: "ToPay\nDDDV", field: "BookedToPayDDDV", styles: { halign: "right" } },
    { content: "Frght\nChrg.", field: "BookedFreight", styles: { halign: "right" } },
    { content: "Doc.\nChrg.", field: "BookedDocumentCharges", styles: { halign: "right" } },
    { content: "Ham.\nChrg.", field: "BookedHamaliCharges", styles: { halign: "right" } },
    { content: "Op.\nHam.", field: "BookedOperatorHamaliChg", styles: { halign: "right" } },
    { content: "Oth.\nChrg", field: "BookedOtherCharges", styles: { halign: "right" } },
    { content: "BkgGST\nChrg.", field: "BookedGST", styles: { halign: "right" } },
    { content: "Booked\nTotal", field: "TotalBoookedPayment", styles: { halign: "right" } },
    { content: "Paid\nAmt.", field: "DeliveredPaid", styles: { halign: "right" } },
    { content: "ToPay\nAmt.", field: "DeliveredToPay", styles: { halign: "right" } },
    { content: "FOC\nAmt.", field: "DeliveredFOC", styles: { halign: "right" } },
    { content: "COD\nAmt.", field: "DeliveredCOD", styles: { halign: "right" } },
    { content: "On\nAccount", field: "DeliveredOnAccount", styles: { halign: "right" } },
    { content: "ToPay\nDDDV", field: "DeliveredToPayDDDV", styles: { halign: "right" } },
    { content: "Del.Ham\nChrg.", field: "DeliveredHamali", styles: { halign: "right" } },
    { content: "Del.Op.Ham\nChrg.", field: "DeliveryOtherHamali", styles: { halign: "right" } },
    { content: "Demm.\nChrg.", field: "DeliveredInsurance", styles: { halign: "right" } },
    { content: "Other\nChrg.", field: "DeliveredOtherCharges", styles: { halign: "right" } },
    { content: "Delivery\nGST", field: "DeliveredGST", styles: { halign: "right" } },
    { content: "Delivery\nTotal", field: "TotalDeliveredPayment", styles: { halign: "right" } }
]

export const cityBranchColumns = [
    {
        id: 1, header: 'City\nName', exportHead: 'City\nName', field: 'CityName', isSelected: true, isDefault: true, isMandatory: true,xlCol: xlCol, isSortIcon: true, weight: 30
    },
    {
        id: 2, header: 'Branch\nName', exportHead: 'Branch\nName', field: 'BranchName', isSelected: true, isDefault: true, isMandatory: true,xlCol: xlCol, isSortIcon: true, weight: 30
    },
    {
        id: 3, header: 'Paid\nAmt.', exportHead: 'Paid\nAmt.', field: 'BookedPaid', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 4, header: 'ToPay\nAmt.', exportHead: 'ToPay\nAmt.', field: 'BookedToPay', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 5, header: 'FOC\nAmt.', exportHead: 'FOC\nAmt.', field: 'BookedFOC', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 6, header: 'COD\nAmt.', exportHead: 'COD\nAmt.', field: 'BookedCOD', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 7, header: 'On\nAccount', exportHead: 'On\nAccount', field: 'BookedOnAccount', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 8, header: 'ToPay\nDDDV', exportHead: 'ToPay\nDDDV', field: 'BookedToPayDDDV', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 9, header: 'Frght\nChrg.', exportHead: 'Frght\nChrg.', field: 'BookedFreight', isSelected: true, isDefault: false, isMandatory: false,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 10, header: 'Doc.\nChrg.', exportHead: 'Doc.\nChrg.', field: 'BookedDocumentCharges', isSelected: true, isDefault: false, isMandatory: false,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 11, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'BookedHamaliCharges', isSelected: true, isDefault: false, isMandatory: false,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 12, header: 'Op.\nHam.', exportHead: 'Op.\nHam.', field: 'BookedOperatorHamaliChg', isSelected: true, isDefault: false, isMandatory: false,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 13, header: 'Oth.\nChrg', exportHead: 'Oth.\nChrg', field: 'BookedOtherCharges', isSelected: true, isDefault: false, isMandatory: false,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 14, header: 'BkgGST.\nChrg.', exportHead: 'BkgGST.\nChrg.', field: 'BookedGST', isSelected: true, isDefault: false, isMandatory: false,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 15, header: 'Booked\nTotal', exportHead: 'Booked\nTotal', field: 'TotalBoookedPayment', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 16, header: 'Paid\nAmt.', exportHead: 'Paid\nAmt.', field: 'DeliveredPaid', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 17, header: 'ToPay\nAmt.', exportHead: 'ToPay\nAmt.', field: 'DeliveredToPay', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 18, header: 'FOC\nAmt.', exportHead: 'FOC\nAmt.', field: 'DeliveredFOC', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 19, header: 'COD\nAmt.', exportHead: 'COD\nAmt.', field: 'DeliveredCOD', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 20, header: 'On\nAccount', exportHead: 'On\nAccount', field: 'DeliveredOnAccount', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 21, header: 'ToPay\nDDDV', exportHead: 'ToPay\nDDDV', field: 'DeliveredToPayDDDV', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 22, header: 'Del.Ham\nChrg.', exportHead: 'Del.Ham\nChrg.', field: 'DeliveredHamali', isSelected: true, isDefault: false, isMandatory: false,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 23, header: 'Del.Op.Ham\nChrg.', exportHead: 'Del.Op.Ham\nChrg.', field: 'DeliveryOtherHamali', isSelected: true, isDefault: false, isMandatory: false,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 24, header: 'Demm.\nChrg.', exportHead: 'Demm.\nChrg.', field: 'DeliveredInsurance', isSelected: true, isDefault: false, isMandatory: false,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 25, header: 'Other\nChrg.', exportHead: 'Other\nChrg.', field: 'DeliveredOtherCharges', isSelected: true, isDefault: false, isMandatory: false,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 26, header: 'Delivery\nGST', exportHead: 'Delivery\nGST', field: 'DeliveredGST', isSelected: true, isDefault: false, isMandatory: false,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 27, header: 'Delivery\nTotal', exportHead: 'Delivery\nTotal', field: 'TotalDeliveredPayment', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
]
export const cityWiseColumns = [
    {
        id: 1, header: 'City\nName', exportHead: 'City\nName', field: 'CityName', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlCol, isSortIcon: true, weight: 30
    },
    {
        id: 2, header: 'Paid\nAmt.', exportHead: 'Paid\nAmt.', field: 'BookedPaid', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 3, header: 'ToPay\nAmt.', exportHead: 'ToPay\nAmt.', field: 'BookedToPay', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 4, header: 'FOC\nAmt.', exportHead: 'FOC\nAmt.', field: 'BookedFOC', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 5, header: 'COD\nAmt.', exportHead: 'COD\nAmt.', field: 'BookedCOD', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 6, header: 'On\nAccount', exportHead: 'On\nAccount', field: 'BookedOnAccount', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 7, header: 'ToPay\nDDDV', exportHead: 'ToPay\nDDDV', field: 'BookedToPayDDDV', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 8, header: 'Frght\nChrg.', exportHead: 'Frght\nChrg.', field: 'BookedFreight', isSelected: true, isDefault: false, isMandatory: false,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 9, header: 'Doc.\nChrg.', exportHead: 'Doc.\nChrg.', field: 'BookedDocumentCharges', isSelected: true, isDefault: false, isMandatory: false,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 10, header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'BookedHamaliCharges', isSelected: true, isDefault: false, isMandatory: false,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 11, header: 'Op.\nHam.', exportHead: 'Op.\nHam.', field: 'BookedOperatorHamaliChg', isSelected: true, isDefault: false, isMandatory: false,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 12, header: 'Oth.\nChrg', exportHead: 'Oth.\nChrg', field: 'BookedOtherCharges', isSelected: true, isDefault: false, isMandatory: false,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 13, header: 'BkgGST.\nChrg.', exportHead: 'BkgGST.\nChrg.', field: 'BookedGST', isSelected: true, isDefault: false, isMandatory: false,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 14, header: 'Booked\nTotal', exportHead: 'Booked\nTotal', field: 'TotalBoookedPayment', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 15, header: 'Paid\nAmt.', exportHead: 'Paid\nAmt.', field: 'DeliveredPaid', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 16, header: 'ToPay\nAmt.', exportHead: 'ToPay\nAmt.', field: 'DeliveredToPay', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 17, header: 'FOC\nAmt.', exportHead: 'FOC\nAmt.', field: 'DeliveredFOC', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 18, header: 'COD\nAmt.', exportHead: 'COD\nAmt.', field: 'DeliveredCOD', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 19, header: 'On\nAccount', exportHead: 'On\nAccount', field: 'DeliveredOnAccount', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 20, header: 'ToPay\nDDDV', exportHead: 'ToPay\nDDDV', field: 'DeliveredToPayDDDV', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 21, header: 'Del.Ham\nChrg.', exportHead: 'Del.Ham\nChrg.', field: 'DeliveredHamali', isSelected: true, isDefault: false, isMandatory: false,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 22, header: 'Del.Op.Ham\nChrg.', exportHead: 'Del.Op.Ham\nChrg.', field: 'DeliveryOtherHamali', isSelected: true, isDefault: false, isMandatory: false,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 23, header: 'Demm.\nChrg.', exportHead: 'Demm.\nChrg.', field: 'DeliveredInsurance', isSelected: true, isDefault: false, isMandatory: false,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 24, header: 'Other\nChrg.', exportHead: 'Other\nChrg.', field: 'DeliveredOtherCharges', isSelected: true, isDefault: false, isMandatory: false,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 25, header: 'Delivery\nGST', exportHead: 'Delivery\nGST', field: 'DeliveredGST', isSelected: true, isDefault: false, isMandatory: false,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
    {
        id: 26, header: 'Delivery\nTotal', exportHead: 'Delivery\nTotal', field: 'TotalDeliveredPayment', isSelected: true, isDefault: true, isMandatory: true,
        xlCol: xlColq, isSortIcon: true, weight: 30
    },
]
export const tableHeader = [
    { headerName: 'Paid\nAmt.', exportHead: 'Paid\nAmt.', field: 'BookedPaid', xlCol: { dataType: 'number', dataFormatter: null }, align: "left" },
    { headerName: 'ToPay\nAmt.', exportHead: 'ToPay\nAmt.', field: 'BookedToPay', xlCol: { dataType: 'number', dataFormatter: null }, align: "left" },
    { headerName: 'FOC\nAmt.', exportHead: 'FOC\nAmt.', field: 'BookedFOC', xlCol: { dataType: 'number', dataFormatter: null }, align: "left" },
    { headerName: 'COD\nAmt.', exportHead: 'COD\nAmt.', field: 'BookedCOD', xlCol: { dataType: 'number', dataFormatter: null }, align: "left" },
    { headerName: 'On\nAccount', exportHead: 'On\nAccount', field: 'BookedOnAccount', xlCol: { dataType: 'number', dataFormatter: null }, align: "left" },
    { headerName: 'ToPay\nDDDV', exportHead: 'ToPay\nDDDV', field: 'BookedToPayDDDV', xlCol: { dataType: 'number', dataFormatter: null }, align: "left" },
    { headerName: 'Frght\nChrg.', exportHead: 'Frght\nChrg.', field: 'BookedFreight', xlCol: { dataType: 'number', dataFormatter: null }, align: "left" },
    { headerName: 'Doc.\nChrg.', exportHead: 'Doc.\nChrg.', field: 'BookedDocumentCharges', xlCol: { dataType: 'number', dataFormatter: null }, align: "left" },
    { headerName: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'BookedHamaliCharges', xlCol: { dataType: 'number', dataFormatter: null }, align: "left" },
    { headerName: 'Op.\nHam.', exportHead: 'Op.\nHam.', field: 'BookedOperatorHamaliChg', xlCol: { dataType: 'number', dataFormatter: null, halign: "left" }, align: "left" },
    { headerName: 'Oth.\nChrg', exportHead: 'Oth.\nChrg', field: 'BookedOtherCharges', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    { headerName: 'BkgGST.\nChrg.', exportHead: 'BkgGST.\nChrg.', field: 'BookedGST', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    { headerName: 'Booked\nTotal', exportHead: 'Booked\nTotal', field: 'TotalBoookedPayment', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    { headerName: 'Paid\nAmt.', exportHead: 'Paid\nAmt.', field: 'DeliveredPaid', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    { headerName: 'ToPay\nAmt.', exportHead: 'ToPay\nAmt.', field: 'DeliveredToPay', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    { headerName: 'FOC\nAmt.', exportHead: 'FOC\nAmt.', field: 'DeliveredFOC', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    { headerName: 'COD\nAmt.', exportHead: 'COD\nAmt.', field: 'DeliveredCOD', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    { headerName: 'On\nAccount', exportHead: 'On\nAccount', field: 'DeliveredOnAccount', xlCol: { dataType: 'number', dataFormatter: null }, align: "left" },
    { headerName: 'ToPay\nDDDV', exportHead: 'ToPay\nDDDV', field: 'DeliveredToPayDDDV', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    { headerName: 'Del.Ham\nChrg.', exportHead: 'Del.Ham\nChrg.', field: 'DeliveredHamali', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    { headerName: 'Del.Op.Ham\nChrg.', exportHead: 'Del.Op.Ham\nChrg.', field: 'DeliveryOtherHamali', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    { headerName: 'Demm.\nChrg.', exportHead: 'Demm.\nChrg.', field: 'DeliveredInsurance', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    { headerName: 'Other\nChrg.', exportHead: 'Other\nChrg.', field: 'DeliveredOtherCharges', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    { headerName: 'Delivery\nGST', exportHead: 'Delivery\nGST', field: 'DeliveredGST', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    { headerName: 'Delivery\nTotal', exportHead: 'Delivery\nTotal', field: 'TotalDeliveredPayment', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
]
export const cityBranchColumnsStyles = {
    0: { halign: 'left', cellWidth: 120, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    1: { halign: 'left', cellWidth: 170, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    2: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    3: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    4: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    5: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    6: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    7: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    8: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    9: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    10: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    11: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    12: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    13: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    14: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    15: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    16: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    17: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    18: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    19: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    20: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    21: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    22: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    23: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    24: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    25: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    26: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
}
export const cityWiseColumnsStyles = {
    0: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    1: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    2: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    3: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    4: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    5: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    6: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    7: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    8: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    9: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    10: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    11: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    12: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    13: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    14: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    15: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    16: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    17: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    18: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    19: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    20: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    21: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    22: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    23: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    24: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    25: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
}

export const updateCityBranchData = (array) => {
    let total = {
        BookedPaid: 0, BookedToPay: 0, BookedFOC: 0, BookedCOD: 0, BookedOnAccount: 0, BookedToPayDDDV: 0, BookedFreight: 0, BookedDocumentCharges: 0,
        BookedHamaliCharges: 0, BookedOperatorHamaliChg: 0, BookedOtherCharges: 0, BookedGST: 0, TotalBoookedPayment: 0, DeliveredPaid: 0, DeliveredToPay: 0, DeliveredFOC: 0,
        DeliveredCOD: 0, DeliveredOnAccount: 0, DeliveredToPayDDDV: 0, DeliveredHamali: 0, DeliveryOtherHamali: 0, DeliveredInsurance: 0, DeliveredOtherCharges: 0, DeliveredGST: 0, TotalDeliveredPayment: 0,
    }
    
    array.forEach((val) => {
        total = {
            BookedPaid: total.BookedPaid + Number(val.BookedPaid),
            BookedToPay: total.BookedToPay + Number(val.BookedToPay),
            BookedFOC: total.BookedFOC + Number(val.BookedFOC),
            BookedCOD: total.BookedCOD + Number(val.BookedCOD),
            BookedOnAccount: total.BookedOnAccount + Number(val.BookedOnAccount),
            BookedToPayDDDV: total.BookedToPayDDDV + Number(val.BookedToPayDDDV),
            BookedFreight: total.BookedFreight + Number(val.BookedFreight),
            BookedDocumentCharges: total.BookedDocumentCharges + Number(val.BookedDocumentCharges),
            BookedHamaliCharges: total.BookedHamaliCharges + Number(val.BookedHamaliCharges),
            BookedOperatorHamaliChg: total.BookedOperatorHamaliChg + Number(val.BookedOperatorHamaliChg),
            BookedOtherCharges: total.BookedOtherCharges + Number(val.BookedOtherCharges),
            BookedGST: total.BookedGST + Number(val.BookedGST),
            TotalBoookedPayment: (Number(total.TotalBoookedPayment) + Number(val.TotalBoookedPayment)).toFixed(2),
            DeliveredPaid: total.DeliveredPaid + Number(val.DeliveredPaid),
            DeliveredToPay: total.DeliveredToPay + Number(val.DeliveredToPay),
            DeliveredFOC: total.DeliveredFOC + Number(val.DeliveredFOC),
            DeliveredCOD: total.DeliveredCOD + Number(val.DeliveredCOD),
            DeliveredOnAccount: total.DeliveredOnAccount + Number(val.DeliveredOnAccount),
            DeliveredToPayDDDV: total.DeliveredToPayDDDV + Number(val.DeliveredToPayDDDV),
            DeliveredHamali: total.DeliveredHamali + Number(val.DeliveredHamali),
            DeliveryOtherHamali: total.DeliveryOtherHamali + Number(val.DeliveryOtherHamali),
            DeliveredInsurance: total.DeliveredInsurance + Number(val.DeliveredInsurance),
            DeliveredOtherCharges: total.DeliveredOtherCharges + Number(val.DeliveredOtherCharges),
            DeliveredGST: total.DeliveredGST + Number(val.DeliveredGST),
            TotalDeliveredPayment: (Number(total.TotalDeliveredPayment) + Number(val.TotalDeliveredPayment)).toFixed(2),
        }
    })
    array.push({
        CityName: "Total", ...total,
         dataType: 'total',
        isTotal: true
    })
    return array
}

export const jsPdfHeaderFooter = (data, userData, totalPagesExp, fontsize) => {
    const doc = data.doc
    // Footer
    var pageSize = doc.internal.pageSize
    var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

    var str = 'Page : ' + doc.internal.getNumberOfPages()
    if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
    }
    doc.setFontSize(fontsize)
    doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 25, "right")
    doc.setFont('Roboto', 'bold')
    doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 25)
    doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 25)
}


export const cityWiseDrawCell = function (data) {
    var rows = data.table.body
    rows.map((val) => {
        if (val.raw.isTotal) {
            val.cells[0].colSpan = 2
            val.cells[0].styles.font = 'Roboto'
            val.cells[0].styles.fontStyle = 'normal'
            val.cells[0].styles.fontS0ze = '16'
            val.cells[0].styles.textColor = [0, 0, 0]
            val.cells[0].styles.halign = 'left'
            val.cells[0].styles.fillColor = [238, 238, 238]
            for (let i = 2; i <= 25; i++) {
                val.cells[i].colSpan = 1
                val.cells[i].styles.font = 'Roboto'
                val.cells[i].styles.fontStyle = 'normal'
                val.cells[i].styles.fontSize = '16'
                val.cells[i].styles.textColor = [0, 0, 0]
                val.cells[i].styles.halign = 'right'
                val.cells[i].styles.fillColor = [238, 238, 238]
            }
        }

    })
}